import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IResponse } from '../models/response.model';
import { CreateTierDTO, Tier, UpdateTierDTO } from '../models/tier.model';

@Injectable({
  providedIn: 'root'
})
export class TiersService {

  url = `${environment.url}/api`;
  
  constructor(
    private http: HttpClient
  ) { }

  tiersBs: BehaviorSubject<Tier[]> = new BehaviorSubject<Tier[]>([]);

  getAll(): Observable<IResponse<Tier[]>> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
    return this.http.get<IResponse<Tier[]>>(`${this.url}/tiersMantenimiento`, { headers });
  }

  create(createTierDTO: CreateTierDTO): Observable<IResponse<Tier>> {
    return this.http.post<IResponse<Tier>>(`${this.url}/tiersMantenimiento`, createTierDTO);
  }

  update(updateTierDTO: UpdateTierDTO): Observable<IResponse<Tier>> {
    return this.http.put<IResponse<Tier>>(`${this.url}/tiersMantenimiento/${updateTierDTO.id}`, updateTierDTO);
  }

  delete(id: number): Observable<IResponse<Tier>> {
    return this.http.delete<IResponse<Tier>>(`${this.url}/tiersMantenimiento/${id}`);
  }

  getTiers(): Tier[] {
    return this.tiersBs.getValue();
  }

  updateTiers(tiers: Tier[]) {
    this.tiersBs.next(tiers);
  }
}
